import React from "react";

import { localizedText } from "shared/lib/localizedMap";

import { OrderDialog } from "features/MenuEditor/components/OrderDialog";
import { useMenuEditorContext } from "features/MenuEditor/context";

export const CategoriesOrderDialog = () => {
    const state = useMenuEditorContext();

    const submit = async (orderedIds: number[]) => {
        const saved = await state.mutations.reorderCategories(orderedIds);
        if (saved) state.closeDialog();
    };

    return (
        <OrderDialog
            title="Порядок категорий"
            description="Перетащите категории — в таком порядке их увидит гость."
            entries={state.categories.map((category) => ({
                id: category.id,
                label: localizedText(category.name, state.locale),
            }))}
            emptyText="Категорий пока нет."
            saving={state.mutations.saving}
            onClose={state.closeDialog}
            onSubmit={submit}
        />
    );
};
